<template>
  <v-card>
    <Loader ref="Loader"></Loader>
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <v-layout fill-height row mr-1 ml-1 mt-2>
      <v-flex xs12 sm12 lg12 xl12>
        <v-toolbar dense color="secondary" dark>
          <v-toolbar-title>Users - Create</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-form @submit.prevent="SubmitForm" ref="form" v-model="valid">
              <v-card-text xs12 mt-3>
                <v-layout row>
                  <v-flex xs6 sm6 md6 lg6 xl6>
                    <v-select v-model="form.UserRoleID" item-text="Name" item-value="ID" :items="roleList"
                      :rules="fieldRules" label="User role"></v-select>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs6>
                    <v-select v-model="form.RegionID" label="Region" :rules="fieldRules" :items="regionList"
                      item-text="Name" item-value="ID"></v-select>
                  </v-flex>
                </v-layout>
                <h3 class="mt-3 mb-2">User details</h3>
                <v-layout xs12 sm12 md4 lg4 xl4 justify-start row>
                  <v-flex xs12 sm12 md4 lg4 xl4 mr-2>
                    <v-text-field label="Title" v-model="form.Title" :rules="fieldRules">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4 mr-2>
                    <v-text-field label="Firstname" v-model="form.FirstName" :rules="fieldRules">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4>
                    <v-text-field label="Lastname" v-model="form.LastName" :rules="fieldRules">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <h3 class="mt-3 mb-2">Additional information</h3>
                <v-layout>
                  <v-flex xs4>
                    <v-text-field label="Company Position" v-model="form.CompanyPosition">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-start row>
                  <v-flex mr-2>
                    <v-text-field label="Contact Telephone Number" v-model="form.ContactTel" mask="phone">
                    </v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-text-field label="Contact Email Address" v-model="form.ContactEmail">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs6>
                    <input ref="autocompleteCustomer" placeholder="Street Address" class="search-location"
                      onfocus="value = ''" type="text">
                  </v-flex>
                </v-layout>
                <v-layout justify-start row>
                  <v-flex mr-2>
                    <v-text-field disabled label="Address Line 1" v-model="form.AddressLine1"></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-text-field disabled label="Address Line 2" v-model="form.AddressLine2"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout justify-start row>
                  <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                    <v-text-field disabled label="Suburb" v-model="form.Suburb"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                    <v-text-field disabled label="Province" v-model="form.Province"></v-text-field>
                  </v-flex>
                </v-layout>

                <h3 class="mt-3 mb-2">Login credentials</h3>
                <v-layout justify-start row>
                  <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                    <v-text-field label="Username" v-model="form.Username" :rules="fieldRules" autocomplete="new-password">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 mr-2>
                    <v-text-field label="Password" :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                      @click:append="showPassword = !showPassword" :type="showPassword ? 'text' : 'password'"
                      v-model="form.Password" :rules="fieldRules" autocomplete="new-password"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row class="text-xs-right">
                  <v-flex>
                    <v-btn color="success" type="submit" :disabled="!valid">
                      Save
                    </v-btn>
                    <v-btn flat @click="$router.push('/users/dashboard')">Cancel</v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-form>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  import JWT from "jsonwebtoken";
  export default {
    data() {
      return {
        showPassword: false,
        place: "",
        places: [],
        form: {
          AccountID: 0,
          RegionID: 0,
          Title: null,
          CompanyPosition: null,
          FirstName: null,
          LastName: null,
          ContactTel: null,
          ContactEmail: null,
          AddressLine1: null,
          AddressLine2: null,
          Suburb: null,
          Province: null,
          Username: null,
          Password: null,
          UserRoleID: null
        },
        roleList: [],
        regionList: [],
        fieldRules: [v => !!v || "Field is required"],
        emailRules: [
          v => !!v || "E-mail is required",
          v => /.+@.+/.test(v) || "E-mail must be valid"
        ],
        valid: true
      };
    },
    mounted() {
      let self = this;
      // MAPS
      this.autocomplete = new google.maps.places.Autocomplete(
        self.$refs.autocompleteCustomer, {
          types: ["address"]
        }
      );
      this.autocomplete.addListener("place_changed", () => {
        self.place = this.autocomplete.getPlace();
        self.form.AddressLine1 =
          self.place.address_components[0].short_name +
          " " +
          self.place.address_components[1].long_name;
        self.form.AddressLine2 =
          self.place.address_components[2].short_name;
        self.form.Suburb = self.place.address_components[3].short_name;
        self.form.Province = self.place.address_components[5].long_name;
        // self.customerForm.Lattitude = self.place.geometry.location.lat();
        // self.customerForm.Longitude = self.place.geometry.location.lng();
      });

      self.FetchRoles();
      self.fetchRegions();
    },
    methods: {
      FetchRoles() {
        let self = this;
        let accountID = JWT.decode(localStorage["accessToken"]).ACCOUNT_ID;
        self.$refs.Loader.show();
        self
          .get(`Roles/Account?accountID=${accountID}`)
          .then(response => {
            self.$refs.Loader.hide();
            self.roleList = response.data;
          })
          .catch(error => {
            console.log(error);
            self.$refs.Loader.hide();
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText("Failed to get roles");
          });
      },
      fetchRegions() {
        let self = this;

        self.get('Region').then(r => {
          self.regionList = r.data;
        })
      },
      SubmitForm() {
        var self = this;
        let Request = JSON.parse(JSON.stringify(self.form));
        Request.AccountID = JWT.decode(localStorage["accessToken"]).ACCOUNT_ID;

        self.$refs.Loader.show();
        self
          .post("SystemUser", Request)
          .then(res => {
            self.$refs.Loader.hide();
            self.$router.push("/users/dashboard");
          })
          .catch(err => {
            console.log(err);
            self.$refs.Loader.hide();
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText("Failed to create user");
          });
        this.$refs.form.reset();
      }
    }
  };
</script>

<style scoped>
</style>